module.exports = __webpack_public_path__ + "static/media/numberofpeople.8da4c8f7.svg";